import { Head, Link } from '@inertiajs/react'

const BROWSER_TOOLS = [
  { href: '/tools/encoding', title: 'Encodings & escapes', body: 'Base64, hex, URI, compression, C/JSON string escapes.' },
  { href: '/tools/json', title: 'JSON', body: 'Prettify and minify JSON in the browser.' },
  { href: '/tools/jwt', title: 'JWT', body: 'Decode header and payload (no signature verification).' },
  { href: '/tools/diff', title: 'Text diff', body: 'Unified line-oriented diff for two texts.' },
  { href: '/tools/hash', title: 'Hashes', body: 'SHA-1, SHA-256, SHA-384, SHA-512 digests.' },
  { href: '/tools/unicode', title: 'Unicode', body: 'NFC, NFD, NFKC, NFKD normalization.' },
  { href: '/tools/color', title: 'Color', body: 'Convert any CSS color to hex, rgb, hsl, and oklch.' },
  {
    href: '/tools/photo-collage',
    title: 'Photo collage',
    body: 'Arrange photos from your device into a resizable grid collage and export it. Nothing leaves your browser.',
  },
] as const

const VISITOR_TOOLS = [
  {
    href: '/tools/about-you',
    title: 'About you',
    body: 'What this site saw on the request, what your browser exposes to scripts here, and what pages can never read.',
  },
] as const

export default function ToolsIndex() {
  return (
    <>
      <Head title="Tools" />
      <div className="space-y-12">
        <section className="space-y-6">
          <header className="border-b border-outline-variant/20 pb-6">
            <h1 className="font-headline text-3xl font-bold tracking-tighter text-on-surface uppercase">Browser tools</h1>
            <p className="mt-2 max-w-2xl font-mono text-xs leading-relaxed tracking-wide text-on-surface-variant">
              Small utilities that run entirely in your browser.
            </p>
          </header>
          <ul className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {BROWSER_TOOLS.map((item) => (
              <li key={item.href} className="flex min-h-0">
                <Link
                  href={item.href}
                  className="flex h-full min-h-[10.5rem] w-full flex-col rounded-lg border border-outline-variant/20 bg-surface-container-low p-5 transition-colors hover:border-primary hover:bg-surface-container-high"
                >
                  <h2 className="font-headline text-lg font-bold tracking-tight text-on-surface uppercase">{item.title}</h2>
                  <p className="mt-2 min-h-0 flex-1 font-mono text-[11px] leading-relaxed text-on-surface-variant">{item.body}</p>
                  <span className="mt-3 inline-block shrink-0 font-mono text-[10px] font-bold tracking-widest text-primary-container uppercase">
                    Open →
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        </section>

        <section className="space-y-6">
          <header className="border-b border-outline-variant/20 pb-6">
            <h2 className="font-headline text-2xl font-bold tracking-tighter text-on-surface uppercase">Visitor and device</h2>
            <p className="mt-2 max-w-2xl font-mono text-xs leading-relaxed tracking-wide text-on-surface-variant">
              Request metadata from the server and browser-facing APIs on this origin.
            </p>
          </header>
          <ul className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {VISITOR_TOOLS.map((item) => (
              <li key={item.href} className="flex min-h-0">
                <Link
                  href={item.href}
                  className="flex h-full min-h-[10.5rem] w-full flex-col rounded-lg border border-outline-variant/20 bg-surface-container-low p-5 transition-colors hover:border-primary hover:bg-surface-container-high"
                >
                  <h2 className="font-headline text-lg font-bold tracking-tight text-on-surface uppercase">{item.title}</h2>
                  <p className="mt-2 min-h-0 flex-1 font-mono text-[11px] leading-relaxed text-on-surface-variant">{item.body}</p>
                  <span className="mt-3 inline-block shrink-0 font-mono text-[10px] font-bold tracking-widest text-primary-container uppercase">
                    Open →
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        </section>
      </div>
    </>
  )
}
